module.exports = __webpack_public_path__ + "img/navigationIcon.baecd0e3.png";